import { DataBean } from "../DataBean";

export class SetPaymentTurnCode extends DataBean {



    public async setPaymentTurnCode(year:any,code:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_setPaymentTurnCode_Number_Number_Number", [year,code,idEmployee]);
    }
    
}